import { render, staticRenderFns } from "./LanguageSelector.vue?vue&type=template&id=536dc4e3&scoped=true&"
import script from "./LanguageSelector.vue?vue&type=script&lang=ts&"
export * from "./LanguageSelector.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageSelector.vue?vue&type=style&index=0&id=536dc4e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536dc4e3",
  null
  
)

export default component.exports